<template>
  <div>
    <div class="indexTip" v-if="tipState">
      <div @click="itemClick(item)" v-for="(item, index) of tipList" :key="index" class="indexTip-item">
        <img :src="item.icon" style="margin: 0 auto" alt="" />
        <div class="mt4 tac">{{ item.title }}</div>

        <div v-if="item.title == '协会电话'" class="tip-phone">0451-87696938</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {
      tipState: false,
      tipList: [
        { icon: '/static/image/index/tip_1.png', title: '设为收藏' },
        { icon: '/static/image/index/tip_2.png', title: '协会电话' },
        { icon: '/static/image/index/tip_3.png', title: '平台登录' },
        { icon: '/static/image/index/tip_4.png', title: '回到顶部' },
      ],
    }
  },
  created() {},
  computed: {
    // ...mapGetters(['winScroll']),
  },
  watch: {},
  mounted() {
    window.onscroll = (e) => {
      var e = e || window.event
      var scrolltop = document.documentElement.scrollTop || document.body.scrollTop
      // console.log(scrolltop)
      if (scrolltop > 500) {
        // console.log(1)
        this.tipState = true
      } else {
        this.tipState = false
      }
    }
  },

  methods: {
    itemClick(item) {
      if (item.title == '设为收藏') {
        this.addFavorite(window.location.href, '哈尔滨市物业协会')
      } else if (item.title == '平台登录') {
        // alert('跳转页面')
        window.open('https://www.hrbwyxh.cn/')
      } else if (item.title == '回到顶部') {
        document.body.scrollTop = document.documentElement.scrollTop = 0
      }
    },
    addFavorite(sURL, sTitle) {
      try {
        window.external.addFavorite(sURL, sTitle)
      } catch (e) {
        try {
          window.sidebar.addPanel(sTitle, sURL, '')
        } catch (e) {
          alert('加入收藏失败，请使用Ctrl+D进行添加')
        }
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.indexTip {
  position: fixed;
  right: 20px;
  // bottom: calc(50vh - 130px);
  top: calc(50vh - 130px);
  width: 63px;
  background: #ffffff;
  border-radius: 7px;
  border: 1px solid #f2f2f2;
  font-size: 12px;
  padding: 6px 0;
  .indexTip-item {
    padding: 10px 0;
    cursor: pointer;
    position: relative;
    .tip-phone {
      width: 0;
      height: 58px;
      line-height: 58px;
      overflow: hidden;
      background: #fff;
      position: absolute;
      right: 62px;
      top: 0;
      z-index: 999;

      text-align: center;
      font-size: 20px;
      border: 0px solid #f2f2f2;
      border-right: none;
      border-radius: 7px 0 0 7px;

      transition: all 0.05s;
    }
    // &:hover {
    //   background: #f2f2f2;
    // }
    &:nth-child(2):hover {
      .tip-phone {
        width: 200px;
        border-width: 1px;
      }
    }
  }

  img {
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/indexTip.vue